['mousedown', 'touchstart', 'click'].forEach(function(eventType) {
  document.addEventListener(eventType, function(e) {
    const btn = e.target.closest('button[name="checkout"], input[name="checkout"], .AOV-CartDrawer-Checkout');
    
    if (btn) {
      handleCheckoutIntercept(e);
    }
  }, true); 
});

function handleCheckoutIntercept(e) {
  const cartItems = document.querySelectorAll('.bogo-item-js');
  const qualifyingCollections = new Map();
  const collectionCounts = new Map();
  cartItems.forEach(item => {
    const qty = parseInt(item.getAttribute('data-quantity') || 0);
    const cols = item.getAttribute('data-product-collections') || '';
    
    cols.split(',').forEach(handle => {
      if (handle) {
        const currentCount = collectionCounts.get(handle) || 0;
        collectionCounts.set(handle, currentCount + qty);
      }
    });
  });

  // Check for Offers
  for (let item of cartItems) {
    const hasTag = item.getAttribute('data-has-bogo') === 'true';
    const collectionHandle = item.getAttribute('data-bogo-collection');
    const vendorName = item.getAttribute('data-vendor') || 'Special Offer';
    const collectionTitle = item.getAttribute('data-collection-title') || ('Special Offer for ' + vendorName);
    const itemQty = parseInt(item.getAttribute('data-quantity') || 0);

    if (hasTag && collectionHandle && collectionHandle !== "") {
      const totalInCollection = collectionCounts.get(collectionHandle) || 0;

      if (totalInCollection > itemQty) {
        continue; // Offer Satisfied
      }
      qualifyingCollections.set(collectionHandle, { 
        vendor: vendorName, 
        heading: collectionTitle, 
        color: '#000000'
      });
    }
  }

  if (qualifyingCollections.size > 0) {
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();

    showBogoModal(qualifyingCollections);
    return false;

  } else {
    
    let hasAnyBogoItem = false;
    for (let item of cartItems) {
       if(item.getAttribute('data-has-bogo') === 'true') hasAnyBogoItem = true;
    }

    if (hasAnyBogoItem) {
        return true; 
    } else {
        const onSaleHandle = 'discount-beauty'; 
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        
        const onSaleMap = new Map();
        onSaleMap.set(onSaleHandle, {
          vendor: 'On Sale',            
          heading: 'Products On Sale', 
          color: '#d32f2f'              
        });
        showBogoModal(onSaleMap);
        return false;
    }
  }
}

function showBogoModal(collectionMap) {
  const modal = document.getElementById('BogoPromoModal');
  const grid = document.getElementById('BogoProductGrid');
  const showMoreContainer = document.getElementById('BogoShowMoreContainer');
  
  if (!modal) {
    window.location.href = '/checkout';
    return;
  }

  grid.innerHTML = '<div class="loading__spinner" style="display:flex; justify-content:center; align-items:center; height: 100px;"><div class="spinner-border">Loading...</div></div>';
  showMoreContainer.innerHTML = ''; 
  modal.show();

  const collections = Array.from(collectionMap.entries()); 
  
  const fetchPromises = collections.map(([handle, info]) => {
    return fetch(`/collections/${handle}/products.json?limit=30`)
      .then(res => res.json())
      .then(data => ({
        handle: handle,
        vendor: info.vendor,
        heading: info.heading,
        color: info.color, 
        products: data.products || []
      }));
  });

  Promise.all(fetchPromises)
    .then(results => {
      const validResults = results.filter(res => res.products.length > 0);
      if (validResults.length === 0) {
        proceedToCheckoutForce();
        return;
      }
      renderTabsAndGrids(validResults);
    })
    .catch(err => {
      console.error(err);
      proceedToCheckoutForce();
    });
}

function getResizedImage(src, size) {
  if (!src) return 'https://cdn.shopify.com/s/images/admin/no-image-large.gif';
  src = src.split('?')[0]; 
  return src.replace(/(\.[^.]*)$/, `_${size}$1`);
}

function renderTabsAndGrids(dataArray) {
  const container = document.getElementById('BogoProductGrid');
  let tabsHtml = '<div class="bogo-tabs-header">';
  let contentHtml = '';

  dataArray.forEach((group, index) => {
    const isActive = index === 0 ? 'active' : '';
    
    tabsHtml += `
      <button class="bogo-tab-btn ${isActive}" onclick="switchBogoTab('${group.handle}', this)">
        ${group.vendor}
      </button>
    `;

    contentHtml += `<div id="tab-${group.handle}" class="bogo-tab-content ${isActive}">`;
    contentHtml += `<h3 class="bogo-collection-heading">${group.heading}</h3>`;

    const INITIAL_SHOW = 4;
    
    group.products.forEach((prod, pIndex) => {
      const rawSrc = prod.images.length > 0 ? prod.images[0].src : '';
      const imageSrc = getResizedImage(rawSrc, '300x');
      const variantId = prod.variants[0].id;
      const price = parseFloat(prod.variants[0].price).toFixed(2);
      
      const isHidden = pIndex >= INITIAL_SHOW;
      const displayStyle = isHidden ? 'display:none;' : 'display:flex;';
      const hiddenClass = isHidden ? 'bogo-hidden-item' : '';

      contentHtml += `
        <div class="bogo-card ${hiddenClass}" style="${displayStyle}">
          <div class="bogo-card__image">
             <img src="${imageSrc}" alt="${prod.title}" width="80" height="100" loading="lazy" style="object-fit: contain; width: 100%; height: 100%;">
          </div>
          <div class="bogo-card__info">
             <span class="bogo-card__vendor">${prod.vendor}</span>
             <h4 class="bogo-card__title">${prod.title}</h4>
             <div class="bogo-card__price">EGP ${price}</div>
          </div>
          <div class="bogo-card__actions">
             <button type="button" onclick="addBogoGift(${variantId}, this)" class="btn-bogo-add">
               Add To Cart
             </button>
          </div>
        </div>
      `;
    });

    if (group.products.length > INITIAL_SHOW) {
      const remaining = group.products.length - INITIAL_SHOW;
      contentHtml += `
        <div class="text-center mt-2">
          <button type="button" class="bogo-show-more-link" onclick="revealBogoItemsInTab(this)">
            Show More (${remaining})
          </button>
        </div>
      `;
    }

    contentHtml += `</div>`;
  });

  tabsHtml += '</div>';

  if (dataArray.length === 1) {
    container.innerHTML = contentHtml;
  } else {
    container.innerHTML = tabsHtml + contentHtml;
  }
}

window.switchBogoTab = function(handle, btnElement) {
  const buttons = document.querySelectorAll('.bogo-tab-btn');
  buttons.forEach(b => b.classList.remove('active'));
  btnElement.classList.add('active');

  const contents = document.querySelectorAll('.bogo-tab-content');
  contents.forEach(c => c.classList.remove('active'));

  const target = document.getElementById(`tab-${handle}`);
  if (target) target.classList.add('active');
};

window.revealBogoItemsInTab = function(btn) {
  const BATCH_SIZE = 4;
  const wrapper = btn.closest('.bogo-tab-content');
  const hiddenItems = wrapper.querySelectorAll('.bogo-hidden-item');
  const allHiddenArray = Array.from(hiddenItems);
  const itemsToReveal = allHiddenArray.slice(0, BATCH_SIZE);
  
  itemsToReveal.forEach(item => {
    item.style.display = 'flex';
    item.classList.remove('bogo-hidden-item');
  });

  const newRemaining = allHiddenArray.length - itemsToReveal.length;
  if (newRemaining > 0) {
    btn.innerText = `Show More (${newRemaining})`;
  } else {
    btn.style.display = 'none';
  }
};

window.addBogoGift = function(variantId, btnElement) {
  btnElement.classList.add('btn--loading');
  btnElement.innerText = 'Adding...';
  
  const formData = {
    'items': [{
      'id': variantId,
      'quantity': 1
    }]
  };

  fetch(window.Shopify.routes.root + 'cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(formData)
  })
  .then(response => {
    window.location.href = '/checkout';
  })
  .catch((error) => {
    console.error('Error:', error);
    window.location.href = '/checkout';
  });
};

window.proceedToCheckoutForce = function() {
  window.location.href = '/checkout';

};
